// src/components/Layout.tsx
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import { useAuth } from "../contexts/AuthContext";
import { FaSignOutAlt } from "react-icons/fa";

const Layout = () => {
  const { user, logout } = useAuth();

  return (
    <div className="flex h-screen">
      <Sidebar />
      <div className="flex-1 bg-gray-50 flex flex-col">
        {/* Header */}
        <div className="bg-white shadow px-6 py-4 flex justify-end items-center gap-4" style={{ zIndex: 0 }}>
          <span className="text-sm text-gray-700">
            <span className="font-semibold">{user?.name || "User"}</span>&nbsp;&nbsp;|
          </span>
          <button
            onClick={logout}
            className="text-red-500 hover:text-red-600 text-xl"
            title="Logout"
          >
            <FaSignOutAlt />
          </button>
        </div>

        {/* Konten utama */}
        <main className="p-6 overflow-y-auto flex-1">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
